import { createCRUDHook } from './createCRUDHook';
import { CustomerOrderPackagingDto } from 'utils/models';
import { TBL_CUSTOMER_ORDER_PACKAGING } from './apiEndPoints';

const { Context, useManager, useConsumer } =
  createCRUDHook<CustomerOrderPackagingDto>({
    entityName: 'CustomerOrderPackaging',
    endpoint: TBL_CUSTOMER_ORDER_PACKAGING,
  });

export const CustomerOrderPackagingContext = Context;
export const useCustomerOrderPackagingManager = useManager;
export const useCustomerOrderPackaging = useConsumer;
